import { render, staticRenderFns } from "./MarginPaddingInputDragBar.vue?vue&type=template&id=4f396d29&"
import script from "./MarginPaddingInputDragBar.vue?vue&type=script&lang=ts&"
export * from "./MarginPaddingInputDragBar.vue?vue&type=script&lang=ts&"
import style0 from "./MarginPaddingInputDragBar.vue?vue&type=style&index=0&id=4f396d29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports